import App from "./App.view";

export default App;
